import { CaseManagementIcon } from '@repo/ui/CaseManagementIcon'
import { COISIcon } from '@repo/ui/COISIcon'
import { DocumentIcon } from '@repo/ui/DocumentIcon'
import { EmailIcon } from '@repo/ui/EmailIcon'
import { KeyDateIcon } from '@repo/ui/KeyDateIcon'
import { RequisitionIcon } from '@repo/ui/RequisitionIcon'
import { SmsIcon } from '@repo/ui/SmsIcon'
import { UserIcon } from '@repo/ui/UserIcon'

export default [
  {
    label: 'Conflict of interest search',
    icon: <COISIcon />,
    target: '?wizard=COIS-NewClient-NewMatter&stage=conflict&step=introduction',
    menuItemId: 1300
  },
  {
    label: 'Client',
    icon: <UserIcon />,
    target: '?wizard=NewClient-NewMatter&stage=client&step=client-details',
    menuItemId: 1110
  },
  {
    label: 'Matter',
    icon: <CaseManagementIcon />,
    target: '?wizard=ExistingClient-NewMatter&stage=matter&step=matter-details',
    menuItemId: 1210
  },
  {
    label: 'Divider2',
    divider: true
  },
  {
    label: 'Document',
    icon: <DocumentIcon />,
    children: [
      {
        label: 'Document',
        target: `/case-management/matters/document-production`,
        appendClientMatterNoToTarget: true,
        requiresCurrentMatter: true,
        menuItemId: 3400
      },
      {
        label : 'Document bundle',
        target : '?wizard=DocumentBundle&stage=create-bundle&step=create-document-bundle',
        appendClientMatterNoToTarget : false,
        requiresCurrentMatter : false,
        requiresBundledocsEnabled : true,
        menuItemId : 1200
      },
      {
        label: 'Lexis form',
        target: '/case-management/matters/lexis-forms',
        requiresCurrentMatter: true,
        menuItemId: 3943
      },
      {
        label: 'Docusign request',
        target: `/case-management/matters/matter-history`,
        appendClientMatterNoToTarget: true,
        requiresCurrentMatter: true,
        menuItemId: 3990
      }
    ]
  },
  {
    label: 'Email',
    icon: <EmailIcon />,
    target: `/case-management/matters/matter-page`,
    appendClientMatterNoToTarget: true,
    postLoadAction: 'sendEmail',
    requiresCurrentMatter: true,
    menuItemId: 1200
  },
  {
    label: 'SMS',
    icon: <SmsIcon />,
    target: `/case-management/matters/matter-page`,
    appendClientMatterNoToTarget: true,
    postLoadAction: 'sendSms',
    requiresCurrentMatter: true,
    menuItemId: 1200
  },
  {
    label: 'Divider3',
    divider: true
  },
  {
    label: 'Key date',
    icon: <KeyDateIcon />,
    target: 'NEWKEYDATE',
    requiresCurrentMatter: false,
    menuItemId: 3100
  },
  {
    label: 'Requisition',
    icon: <RequisitionIcon />,
    target: `/accounts/client-ledger/requisition`,
    appendClientMatterNoToTarget: true,
    requiresCurrentMatter: true,
    menuItemId: 5300
  }
]
